
// SVG Icon: opened
export default { id: "terriajs-opened" };
export const id = "terriajs-opened";
export const name = "opened";
